import * as Sentry from "@sentry/nextjs";
import { SPLIDE_SCRIPT_SRC, SPLIDE_CSS_HREF } from "./splide-constants.js";
export function loadSplideCss() {
    if (!document.querySelector(`link[href="${SPLIDE_CSS_HREF}"]`)) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = SPLIDE_CSS_HREF;
        document.head.appendChild(link);
    }
}
export function loadSplideSrc() {
    return new Promise((resolve, reject)=>{
        if (window.Splide) {
            resolve();
        }
        const script = document.createElement("script");
        script.src = SPLIDE_SCRIPT_SRC;
        script.async = true;
        script.onload = ()=>{
            resolve();
        };
        script.onerror = (err)=>{
            Sentry.captureException(err);
            Sentry.captureMessage(`Failed to load Splide script: ${err.message}`);
            reject(err);
        };
        document.body.appendChild(script);
    });
}
